import findParent from "./custom/findParent";
function childClose(isSuccess=true, data) {
  let parentWin = findParent();
  if (parentWin && parentWin.parentClose) {
    parentWin.parentClose(isSuccess, data)
  }
}

export default childClose
